import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { baseApi } from '../api';
import { setupInterceptors } from '../api/token-interceptors';

const useAxiosInterceptors = () => {
    const interceptorRef = useRef(setupInterceptors({ nav: useNavigate() }));
    const [isInterceptorsSet, setIsInterceptorsSet] = useState(false);

    useEffect(() => {
        const { req, reqErr, res, resErr } = interceptorRef.current;
        const reqInterceptorId = baseApi.interceptors.request.use(req, reqErr);
        const resInterceptorId = baseApi.interceptors.response.use(res, resErr);
        setIsInterceptorsSet(true);
        return () => {
            baseApi.interceptors.request.eject(reqInterceptorId);
            baseApi.interceptors.response.eject(resInterceptorId);
            setIsInterceptorsSet(false);
        };
    }, []);

    return isInterceptorsSet;
};

export default useAxiosInterceptors;
